import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const PlayIcon = ({ size }: IconSvgProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_5565_6290)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M37.999 10.5H9.99902V38.5H37.999V10.5ZM17.0027 16C15.8981 16 15.0027 16.8954 15.0027 18C15.0027 19.1046 15.8981 20 17.0027 20C18.1073 20 19.0027 19.1046 19.0027 18C19.0027 16.8954 18.1073 16 17.0027 16ZM17.0027 29C15.8981 29 15.0027 29.8954 15.0027 31C15.0027 32.1046 15.8981 33 17.0027 33C18.1073 33 19.0027 32.1046 19.0027 31C19.0027 29.8954 18.1073 29 17.0027 29ZM15.0027 24.5C15.0027 23.3954 15.8981 22.5 17.0027 22.5C18.1073 22.5 19.0027 23.3954 19.0027 24.5C19.0027 25.6046 18.1073 26.5 17.0027 26.5C15.8981 26.5 15.0027 25.6046 15.0027 24.5ZM31.999 19.5139L21.999 19.5139V16.5139L31.999 16.5139V19.5139ZM31.999 26L21.999 26V23L31.999 23V26ZM21.999 32.5H31.999V29.5H21.999V32.5Z"
                    fill="#101214"
                />
            </g>
            <rect x="11.999" y="12.5" width="24" height="24" fill="#101214" />
            <path
                d="M30.999 24L19.749 30.4952L19.749 17.5048L30.999 24Z"
                fill="white"
            />
            <defs>
                <clipPath id="clip0_5565_6290">
                    <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(-0.000976562 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
